module.exports = __webpack_public_path__ + "static/media/share-button.df1e9621.png";